import { attachItemToCartRuleIfProductMatch } from '../lib/actions/add-product'

export default async function (event, payload) {
    const handlers = window.addiesaas.store.getters['Marketing/CartRules/Session/handlers'] || {};
    for (const ruleId in handlers) {
        if (event in handlers[ruleId]) {
            for (const handler of handlers[ruleId][event]) {
                switch (handler.handler) {
                    case 'attachItemToCartRuleIfProductMatch':
                        await attachItemToCartRuleIfProductMatch(payload, handler)
                        break
                    default:
                        console.warn(`Unknown cart rule session handler: ${handler.handler}`, handler)
                }
            }
        }
    }
}
